const $ = require('jquery');

module.exports = function ($timeout) {
    return function (elementOrCb) {
        return $timeout(function () {
            // If the element passed was a function, execute the function.
            const element = typeof elementOrCb === 'function' ? elementOrCb() : elementOrCb;

            // Use the jquery object passed, or select one.
            const $element = element instanceof $ ? element : $(element);
            if ($element.length) {
                // check to see if item can accept focus
                if (!$element.is(':focusable') && typeof $element.attr('tabindex') === 'undefined') {
                    $element.attr('tabindex', '-1');
                }

                $element.focus();
            }
        }, 0, false);
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/movefocus/movefocus-factory.js
 **/